import React from "react";

const Oddish = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-0.25 -1.15 183.95 180.7"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M183.2 55.55 Q183.7 56.15 182.25 56.45 L179.3 56.9 Q176.45 57.65 169.25 66.05 L157.5 79.7 Q154.0 83.35 144.8 90.15 136.65 96.15 132.7 98.45 129.35 100.45 126.35 103.85 L124.05 106.85 Q136.05 114.55 140.5 124.4 144.7 133.75 141.1 142.45 137.45 151.25 126.9 156.4 115.5 162.0 98.9 161.85 78.6 161.7 67.15 154.15 57.3 147.65 55.55 136.95 54.0 127.35 59.2 118.15 64.4 109.0 73.25 105.55 L68.05 104.75 Q61.95 103.55 57.5 101.75 52.8 99.9 39.6 92.65 28.1 86.35 23.9 83.7 18.3 80.25 3.25 75.35 0.45 74.45 0.1 73.6 -0.25 72.65 1.6 70.6 4.6 67.25 11.45 63.55 20.7 58.5 29.8 57.85 34.95 57.45 41.4 58.95 L46.8 60.5 Q43.25 56.4 31.85 41.85 30.5 40.1 27.15 38.25 L23.05 36.25 Q19.0 34.25 19.0 32.8 18.95 31.35 25.95 29.4 33.0 27.45 37.75 27.65 47.15 28.1 61.4 37.95 68.5 42.85 73.75 47.7 72.45 39.75 71.8 28.15 71.45 22.35 71.4 18.1 68.6 19.05 62.55 21.9 60.0 23.1 61.15 20.35 63.7 14.45 68.95 8.25 75.25 0.9 80.25 0.1 87.9 -1.15 99.15 16.25 107.75 29.55 110.35 37.8 116.8 26.15 125.05 20.0 133.9 13.4 144.25 13.5 146.8 13.55 148.45 14.55 150.2 15.6 148.75 16.4 141.6 20.4 138.95 34.9 138.45 37.6 137.3 53.15 136.9 58.35 135.15 63.55 L133.45 67.7 Q154.05 48.65 169.5 49.25 178.45 49.55 183.2 55.55"
        />
        <path
          fill="#00a63c"
          d="M167.2 51.05 Q173.85 50.6 179.95 55.0 L178.4 55.1 Q176.4 55.55 174.25 57.2 172.9 58.25 169.4 62.4 L161.65 71.45 Q149.1 85.2 133.8 95.4 125.1 100.7 121.35 107.65 L121.8 109.1 85.6 107.1 84.7 105.2 Q84.0 103.25 84.85 102.9 86.5 102.25 85.75 101.7 84.95 101.15 82.7 101.7 L74.7 103.8 Q61.6 102.05 48.5 95.25 32.65 85.95 22.2 80.35 17.25 77.7 9.1 75.1 3.1 73.2 3.05 72.35 3.05 70.3 12.35 65.4 23.05 59.75 32.75 59.6 42.2 59.45 53.35 65.3 57.45 67.45 66.9 73.95 72.35 77.7 81.25 85.1 L87.45 100.05 Q88.55 102.35 89.25 101.75 89.9 101.15 89.05 99.15 80.3 79.0 75.75 46.55 71.9 18.75 73.7 10.05 73.95 8.9 73.5 8.7 73.05 8.45 72.5 9.2 72.05 9.75 71.75 13.1 L71.55 16.35 Q69.05 16.75 65.45 18.5 L62.35 20.15 68.9 11.15 Q76.35 2.15 80.9 2.1 85.8 2.05 92.9 11.55 97.45 17.6 104.8 30.65 108.15 36.75 110.2 48.55 111.75 57.75 111.9 65.6 112.05 75.75 111.7 81.05 111.3 86.75 110.05 90.85 109.4 93.05 109.8 93.55 110.15 94.0 111.0 92.2 113.35 87.25 113.95 76.3 L114.1 65.1 Q114.1 59.0 112.7 49.1 L111.3 40.4 Q118.65 27.25 126.65 21.1 135.55 14.25 146.1 15.25 L144.85 16.25 Q143.3 17.8 141.5 20.55 139.25 23.95 137.2 33.75 135.1 43.9 135.0 52.5 134.85 60.35 130.85 68.1 127.9 73.9 121.1 82.25 116.15 88.35 113.5 93.1 112.3 95.2 111.15 98.1 110.65 99.4 110.8 100.55 111.0 101.7 111.5 100.7 114.65 94.65 120.25 86.6 125.1 79.7 128.85 75.4 135.55 67.65 146.6 60.0 158.7 51.7 167.2 51.05"
        />
        <path
          fill="#00a63c"
          d="M36.65 29.8 Q42.8 29.15 54.0 35.7 63.85 41.5 73.9 50.45 74.45 55.5 76.5 65.75 78.85 77.25 80.5 81.45 L68.75 72.4 Q55.75 62.9 49.4 60.7 44.7 55.15 42.2 51.35 40.15 48.25 36.15 43.65 31.85 38.7 30.1 37.65 28.55 36.7 24.6 34.8 L20.9 33.15 25.0 31.85 Q30.35 30.45 36.65 29.8"
        />
        <path
          fill="#0d131a"
          d="M81.5 97.1 Q82.75 97.6 83.0 98.1 83.2 98.6 82.2 98.45 79.45 98.0 76.3 96.5 73.8 95.3 72.0 93.9 58.8 83.35 48.8 78.1 35.9 71.3 22.45 69.65 21.2 69.5 22.0 69.15 L23.8 68.85 Q35.4 69.1 51.85 77.95 64.4 84.7 72.5 91.85 73.85 93.05 77.1 94.85 80.05 96.55 81.5 97.1"
        />
        <path
          fill="#0d131a"
          d="M46.05 38.65 Q53.35 43.15 59.05 48.45 64.25 53.35 78.05 69.65 L79.05 74.55 Q74.65 67.7 58.15 50.2 52.85 44.65 44.65 39.6 36.8 34.8 32.75 34.35 30.9 34.15 31.75 33.75 32.65 33.3 33.85 33.45 38.15 33.8 46.05 38.65"
        />
        <path
          fill="#0d131a"
          d="M83.6 8.15 Q83.1 7.15 83.5 6.65 83.85 6.1 84.85 7.8 89.8 16.1 94.0 28.05 98.55 41.0 100.4 53.15 102.15 64.45 102.5 72.6 102.9 81.45 102.25 97.1 102.15 100.3 101.4 99.7 100.65 99.05 100.85 95.8 101.25 90.55 100.55 77.55 99.8 63.65 98.4 54.15 96.7 42.35 92.7 30.2 88.95 18.6 83.6 8.15"
        />
        <path
          fill="#0d131a"
          d="M135.4 18.8 Q137.0 17.2 137.1 17.55 137.15 17.9 135.6 20.4 L132.1 25.1 Q128.75 29.75 126.8 33.95 123.3 41.5 119.45 53.6 L117.1 61.9 113.6 73.6 113.5 68.8 Q115.85 60.15 118.5 51.3 121.85 40.2 123.65 36.0 125.8 31.1 128.35 27.3 131.2 23.05 135.4 18.8"
        />
        <path
          fill="#0d131a"
          d="M172.15 55.4 Q161.35 58.25 152.75 64.7 150.15 66.65 135.9 79.7 L124.55 91.3 115.75 100.65 Q115.15 101.35 114.4 101.4 113.6 101.5 114.4 100.5 L122.6 91.0 Q131.05 81.6 137.15 75.95 151.05 63.05 159.55 58.3 165.55 54.95 172.1 54.4 173.25 54.3 173.45 54.65 173.65 55.0 172.15 55.4"
        />
        <path
          fill="#767cba"
          d="M57.85 133.4 Q57.6 117.05 71.8 108.35 82.9 101.55 97.9 101.35 115.2 101.1 129.45 113.05 138.3 120.5 139.75 130.65 141.25 141.05 134.05 148.4 129.0 153.6 119.7 156.45 110.75 159.2 99.05 159.35 82.25 159.6 71.2 153.8 58.05 146.95 57.85 133.4"
        />
        <path
          fill="#0d131a"
          d="M111.1 122.95 Q109.7 123.0 108.7 122.0 107.7 121.05 107.7 119.65 107.65 118.25 108.65 117.25 109.6 116.25 111.0 116.25 112.4 116.2 113.4 117.2 114.35 118.15 114.4 119.55 114.45 120.95 113.45 121.95 112.5 122.95 111.1 122.95"
        />
        <path
          fill="#e9545d"
          d="M111.05 121.65 Q110.25 121.7 109.6 121.1 109.0 120.5 108.95 119.65 108.95 118.8 109.55 118.15 110.15 117.55 111.0 117.55 111.85 117.5 112.5 118.1 113.1 118.7 113.1 119.55 113.15 120.4 112.55 121.05 111.9 121.65 111.05 121.65"
        />
        <path
          fill="#0d131a"
          d="M85.1 123.35 Q83.7 123.4 82.75 122.4 81.75 121.45 81.7 120.05 81.7 118.65 82.65 117.65 83.6 116.65 85.0 116.65 86.4 116.6 87.4 117.6 88.4 118.55 88.45 119.95 88.45 121.35 87.45 122.35 86.5 123.35 85.1 123.35"
        />
        <path
          fill="#e9545d"
          d="M85.1 122.05 Q84.25 122.1 83.6 121.5 83.0 120.85 83.0 120.0 83.0 119.15 83.6 118.55 84.2 117.95 85.05 117.9 85.9 117.9 86.5 118.5 87.1 119.1 87.15 119.95 87.15 120.8 86.55 121.45 85.95 122.05 85.1 122.05"
        />
        <path
          fill="#0d131a"
          d="M95.1 130.7 L101.7 130.8 101.05 133.5 Q100.1 136.15 98.4 136.2 96.75 136.25 95.75 133.45 L95.1 130.7"
        />
        <path
          fill="#ed8599"
          d="M96.45 132.0 L100.25 131.95 Q99.7 135.15 98.4 135.15 97.6 135.2 96.95 133.6 L96.45 132.0"
        />
        <path
          fill="#0d131a"
          d="M124.65 178.25 Q114.45 179.55 111.5 173.85 106.5 164.1 121.95 155.75 138.05 146.95 146.65 145.4 156.7 143.55 159.7 150.8 162.2 156.9 158.2 162.5 153.9 168.45 143.0 172.85 131.85 177.35 124.65 178.25"
        />
        <path
          fill="#767cba"
          d="M154.6 148.35 Q158.0 150.2 158.25 154.15 158.5 158.2 155.35 162.1 151.8 166.45 145.2 168.95 145.65 167.75 138.95 165.8 131.6 163.7 126.2 165.65 119.75 168.0 114.35 174.2 111.65 171.85 112.3 168.15 113.15 162.9 121.35 158.45 137.35 149.8 145.15 147.75 150.95 146.25 154.6 148.35"
        />
        <path
          fill="#666ba1"
          d="M124.05 176.05 Q113.8 176.65 114.1 173.2 114.4 169.7 126.05 165.5 132.75 163.05 139.7 164.85 146.15 166.5 145.2 169.0 L133.9 173.7 Q128.0 175.8 124.05 176.05"
        />
        <path
          fill="#0d131a"
          d="M40.2 162.4 Q36.4 157.6 38.6 152.2 41.15 145.95 50.25 146.3 58.3 146.65 68.2 151.75 77.9 156.7 83.1 163.0 88.85 169.85 85.6 174.55 82.6 178.95 74.6 177.95 67.75 177.1 54.8 171.85 44.2 167.6 40.2 162.4"
        />
        <path
          fill="#767cba"
          d="M71.3 165.65 Q65.9 163.7 59.75 164.15 55.2 164.5 53.3 165.5 51.8 166.3 52.5 168.25 46.1 165.4 42.55 161.25 38.25 156.2 41.3 152.0 44.55 147.55 52.65 148.55 59.75 149.4 68.2 153.95 76.3 158.3 81.0 163.55 86.1 169.2 84.3 172.8 L83.4 174.05 Q78.3 168.2 71.3 165.65"
        />
        <path
          fill="#666ba1"
          d="M70.4 174.65 Q62.6 172.7 52.5 168.25 51.1 164.5 57.35 163.65 63.5 162.85 71.3 165.65 78.3 168.2 83.4 174.05 80.8 177.2 70.4 174.65"
        />
        <path
          fill="#0d131a"
          d="M124.65 107.3 L124.4 108.2 Q124.0 109.0 123.35 108.45 L119.5 106.3 Q116.55 104.7 117.1 104.3 117.7 103.85 120.6 105.1 123.2 106.2 124.65 107.3"
        />
        <path
          fill="#009233"
          d="M28.7 84.1 L16.2 77.5 8.65 75.15 Q2.9 73.25 3.2 72.75 11.25 70.45 26.5 77.6 28.45 78.5 52.35 91.7 62.85 97.55 71.5 100.15 77.35 101.9 81.75 102.0 L74.7 103.8 69.25 102.9 Q65.0 101.95 61.3 100.8 56.05 99.8 41.2 91.1 37.5 88.95 28.7 84.1"
        />
        <path
          fill="#666ba1"
          d="M70.5 153.75 Q62.3 149.2 59.45 141.5 61.9 145.75 70.95 149.65 83.95 155.25 103.2 155.1 132.7 154.85 139.85 132.65 L139.85 131.9 Q141.5 140.8 133.95 148.6 124.3 158.6 103.7 159.35 82.2 160.2 70.5 153.75"
        />
        <path
          fill="#009233"
          d="M172.75 56.7 Q176.8 54.55 179.95 55.0 176.05 55.3 171.75 59.7 L167.15 65.3 162.15 70.95 154.65 78.95 Q152.3 81.4 144.55 87.5 136.15 94.2 132.3 96.35 129.15 98.2 126.05 101.35 123.6 103.85 122.3 105.95 121.5 105.4 120.3 104.95 121.1 103.55 126.05 98.95 131.9 93.5 136.55 90.6 141.35 87.6 147.3 81.6 L160.35 67.35 Q167.15 59.7 172.75 56.7"
        />
      </g>
    </svg>
  );
};

export default Oddish;
